import { render, staticRenderFns } from "./avisoprivacidadsimplificado.vue?vue&type=template&id=274548a8&"
import script from "./avisoprivacidadsimplificado.vue?vue&type=script&lang=js&"
export * from "./avisoprivacidadsimplificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports